import { setupReactNative } from "@tamagui/core";
import * as React from "react";
import { Text, View } from "react-native";
globalThis.React = React;
setupReactNative({
  View,
  Text
});
if (typeof requestAnimationFrame === "undefined") {
  globalThis["requestAnimationFrame"] = setImmediate;
}
const cancelAnimationFrame = globalThis.cancelAnimationFrame;
global.cancelAnimationFrame = (x) => {
  try {
    cancelAnimationFrame(x);
  } catch {
  }
};
const idFn = () => {
};
export {
  idFn
};
//# sourceMappingURL=setup.js.map
